// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerCompanyModel } from '~/modules/manager/models/company.model';

export class ManagerCompanyDataClient extends AbstractDataClient<ManagerCompanyModel> {
  constructor() {
    super(new ManagerCompanyModel());
  }
}
